module.exports = __webpack_public_path__ + "static/img/team-technology.33e12889.png";